import * as React from 'react'

import { Button, SelectOption } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onSubmitCustomValues: (customValue: string) => void
  onCloseModal: () => void
  customValues: SelectOption[]
}

const CustomValuesModal = ({ onSubmitCustomValues, onCloseModal, customValues }: Props) => {
  const [customValue, setCustomValue] = React.useState<string>('')
  const onSubmit = () => onSubmitCustomValues(customValue)

  return (
    <Modal
      title={i18n.t('payroll_bundle.sepa_generator.custom_values_modal.title')}
      description={i18n.t('payroll_bundle.sepa_generator.custom_values_modal.description')}
      illustration="clock-app"
      onSubmit={onSubmit}
      onClose={onCloseModal}
      footer={
        <>
          <Button onClick={onCloseModal} type="secondary">
            {i18n.t('payroll_bundle.sepa_generator.custom_values_modal.cancel')}
          </Button>
          <Button onClick={onSubmit} type="primary" disabled={customValue === ''}>
            {i18n.t('payroll_bundle.sepa_generator.custom_values_modal.add_value')}
          </Button>
        </>
      }
    >
      <SelectField
        none={i18n.t('common.none')}
        value={customValue}
        options={customValues}
        onChange={(value) => setCustomValue(value)}
      />
    </Modal>
  )
}

export default CustomValuesModal
